import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ModifyTerminalAction = "MODIFY_TERMINAL";
const SaveTerminalAction = "SAVE_TERMINAL";
const DeleteTerminalAction = "DELETE_TERMINAL";
const ListTerminalsAction = "LIST_TERMINALS";
const ListMerchantsAction = "LIST_MERCHANTS";
const Waiting = "WAITNG";

const initialState = {
    mlist: [],
    tlist: [],
    nowWainting: false,
    editing: null
};
export const actionCreators = {
    /**
     * 加盟店一覧を取得します。
     */
    listMerchants: (token) => async (dispatch) => {
        const routeurl = `api/user/merchants/list`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const mlist = await response.json();
                dispatch({ type: ListMerchantsAction, mlist });
                return mlist;
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
    /**
     * 端末一覧を取得します。
     */
    listTerminals: (token, merchantId, shopId) => async (dispatch) => {
        var routeurl = `api/user/terminals/list`;

        if (merchantId != null) {
            routeurl += `?id=${merchantId}`;
        }
        if (shopId) {
            routeurl += `&shopId=${shopId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    const tlist = resp.result;
                    dispatch({ type: ListTerminalsAction, tlist });
                    return tlist;

                } else {

                    throw new Error(resp.error_message || 'データ取得に失敗しました。');

                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 端末情報を編集します。
     */
    modifyTerminal: (terminal) => async (dispatch) => {
        dispatch({ type: ModifyTerminalAction, terminal, nowWainting: false });
    },

    /**
     * 編集を保存します。
     */
    save: (token, terminal) => async (dispatch) => {
        var routeurl = `api/user/terminals`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(terminal)
            })

            var addNew = false;

            // IDがまだないものは新規登録とみなす
            if (terminal.id == null || terminal.id == '') {

                addNew = true;
            }

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveTerminalAction, terminal: resp.result, addNew });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '登録に失敗しました。');

                }
            } else {
                throw new Error('登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, terminalId, merchantId) => async (dispatch) => {
        var routeurl = `api/user/terminals/edit`;

        routeurl += `?merchantId=${merchantId}`;
        if (terminalId != null) {
            routeurl += `&id=${terminalId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {

                    const terminal = resp.result;
                    dispatch({ type: ModifyTerminalAction, terminal });
                    return terminal;

                } else {

                    throw new Error(resp.error_message || 'データ取得に失敗しました。');

                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 端末の削除
     */
    delete: (token, terminal) => async (dispatch) => {
        var routeurl = `api/user/terminals`;

        // 有効日付(終了)を過去日(前日)に設定
        var nowdt = new Date();
        var stopdt = new Date();
        stopdt.setDate(nowdt.getDate() - 1);
        stopdt = stopdt.getFullYear() + '-' + ("0" + (stopdt.getMonth() + 1)).slice(-2) + '-' + ("0" + stopdt.getDate()).slice(-2);
        terminal.apply_stop_dt = stopdt;

        // 大小関係チェック
        if (terminal.apply_start_dt > terminal.apply_stop_dt) {
            terminal.apply_start_dt = stopdt;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(terminal)
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: DeleteTerminalAction, terminal: resp.result });
                    return resp.result;

                } else {
                    throw new Error(resp.error_message || '削除に失敗しました。');
                }
            } else {
                throw new Error('削除に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 端末撤去
     */
    removal: (token, terminal) => async (dispatch) => {
        var routeurl = `api/user/terminals`;

        // 設置フラグを未設置に設定
        terminal.is_installed = false;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(terminal)
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: ModifyTerminalAction, terminal: resp.result });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '撤去に失敗しました。');
                }
            } else {
                throw new Error('撤去に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
　　// 更新
    if (action.type === ModifyTerminalAction) {
        return {
            ...state,
            editing: action.terminal,
            nowWainting: action.nowWainting
        };
    }
    // 加盟店リスト
    if (action.type === ListMerchantsAction) {
        return {
            ...state,
            mlist: action.mlist,
            nowWainting: action.nowWainting
        };
    }
    // 端末リスト
    if (action.type === ListTerminalsAction) {
        return {
            ...state,
            tlist: action.tlist,
            nowWainting: action.nowWainting
        };
    }
　　// 登録・更新
    if (action.type === SaveTerminalAction) {

        if (action.addNew) {
            // 端末の新規登録時の場合はリストに追加
            state.tlist.push(action.terminal);
        }
        else {
            // 変更の場合はリストを変更
            var idx = state.tlist.findIndex((o) => o.id == action.terminal.id);
            state.tlist[idx] = action.terminal;
        }

        return {
            ...state,
            editing: action.terminal
        };
    }
    // 削除
    if (action.type === DeleteTerminalAction) {
        // 削除の場合はリストから除去
        state.tlist = state.tlist.filter((o) => o.id != action.terminal.id);

        return {
            ...state,
            editing: action.terminal
        };
    }
    return state;
}